import { Component, Input, OnChanges } from '@angular/core';

import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { NgClass } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'span-tooltip',
    templateUrl: './span-tooltip.component.html',
    standalone: true,
    imports: [TooltipModule, NgClass, AfTranslatePipe]
})

export class SpanTooltipComponent implements OnChanges{
  constructor(private commonUtilsService: CommonUtilsService) { }

  @Input() text:string = '';
  @Input() tooltipText:string = '';
  @Input() otherText:string = '';
  @Input() tooltipPosition:any = 'bottom';
  @Input() showTooltipAlway:boolean = false;
  @Input() isDeleted:boolean = false;
  @Input() multiline: number=0;

  spanTooltip: any = {
    id: this.commonUtilsService.createId(),
    tooltipText: ''
  }

  ngOnChanges(): void {
    this.spanTooltip.tooltipText = this.tooltipText?this.tooltipText:this.text;
  }

  showTooltip():boolean{
    if(this.isDeleted || this.showTooltipAlway){
      return false;
    }else if(this.multiline && this.multiline > 1){
      return !this.commonUtilsService.showTooltipHeight(this.spanTooltip.id);
    }
    return !this.commonUtilsService.showTooltip(this.spanTooltip.id);
  }

}
